import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';

const kept = new Map<string, unknown>();

/**
 * useState, который переживает размонтирование экрана: VKUI 8.4 держит только
 * активную панель, и возврат с карточки собирал список с умолчаний.
 *
 * Память модульная — не адрес (вкладка не должна ложиться шагом в историю) и
 * не localStorage (это место, где остановились, а не настройка). Первое
 * значение запоминается тоже, поэтому вкладка из прямой ссылки читается один
 * раз за жизнь документа. Без ключа — обычное состояние.
 */
export function useKeptState<T>(
  key: string | undefined,
  initial: T | (() => T),
): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    const saved = key === undefined ? undefined : kept.get(key);
    if (saved !== undefined) return saved as T;
    return typeof initial === 'function' ? (initial as () => T)() : initial;
  });

  // Пишем эффектом: рендер модульную память не трогает.
  useEffect(() => {
    if (key !== undefined) kept.set(key, value);
  }, [key, value]);

  return [value, setValue];
}
